import { render } from "./ChampionshipTeams.vue?vue&type=template&id=c454b56e&scoped=true"
import script from "./ChampionshipTeams.vue?vue&type=script&lang=js"
export * from "./ChampionshipTeams.vue?vue&type=script&lang=js"

import "./ChampionshipTeams.vue?vue&type=style&index=0&id=c454b56e&scoped=true&lang=css"

import exportComponent from "D:\\Abdullah\\Projects\\R-Sport\\System\\rsport_dashboard\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c454b56e"]])

export default __exports__